import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { StaffMemberResponsible } from 'frontend/types/profile';

interface StaffMemberResponsibleState {
  staffMemberResponsible: StaffMemberResponsible;
}

const stateModule: Module<StaffMemberResponsibleState, RootState> = {
  namespaced: true,
  state: {
    staffMemberResponsible: {} as StaffMemberResponsible,
  },

  mutations: {
    setValue(state: StaffMemberResponsibleState, value: StaffMemberResponsible) {
      state.staffMemberResponsible = value;
    },
  },
};

export default stateModule;
